import React, { useEffect, useState } from "react"
import { Col, Form, Row } from "react-bootstrap"
import toast from "react-hot-toast"
import { connect, useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import { Loader, SelectPicker } from "rsuite"
import Constant from "../../../constant"
import Dateinfo from "../../components/Dateinfo"
import ErrorField from "../../components/Errorfield"
import { GreyCard } from "../../components/styled/Generalcard"
import { fetchMasterData } from "../../redux/action/masterDataAction"
import { getProcurement, fetchProcurementItems, updateProcurementInfo } from "../../redux/action/procurementAction"

function InitiationInfoForm({
   isAppLoading,
   dataMasters,
   readOnly = false,
   passedInRef,
   handleExpand,
   handleGetFormState,
   dataProcurementItems,
   negotiationBatch,
}) {
   const dispatch = useDispatch()
   const { procurementId } = useParams()
   const [errors, setErrors] = useState([])
   const [isLoading, setIsLoading] = useState(false)
   const [formState, setFormState] = useState({
      procurementNumber: "",
      endDate: "",
      procurementName: "",
      negotiationType: "",
      evaluationMethod: "",
      biddingType: "",
      winnerType: "",
      currencyType: "",
      priceIncludeTax: false,
      currency: "",
      currencyId: null,
      currencyTypeId: null,
   })

   const getProcurementData = (_dataMaster) => {
      new Promise((resolve, reject) => {
         setIsLoading(true)
         dispatch(
            getProcurement(
               { procurementId },
               (result) => {
                  setFormState((prev) => ({ ...prev, ...result }))
                  resolve()
               },
               () => {
                  toast.error("Data not found")
                  reject()
               },
               _dataMaster,
            ),
         )
      })
         .then()
         .catch()
         .finally(() => {
            setIsLoading(false)
         })
   }

   useEffect(() => {
      const language = window.localStorage.getItem("lang")
      // if (!dataMasters) {
      dispatch(
         fetchMasterData(language, (masterData) => {
            getProcurementData(masterData)
         }),
      )
      // }
      dispatch(fetchProcurementItems({ procurementId }))
   }, [])

   const capitalizeFirstLetterEachWord = (sentence = "") => {
      return sentence
         .split("_")
         .map((word) => {
            return word[0] + word.substring(1).toLowerCase()
         })
         .join(" ")
   }

   return (
      <div
         ref={passedInRef}
         id="procurement"
         onMouseEnter={() => {
            if (handleExpand) handleExpand({ expand: "procurement" })
         }}
      >
         <Row>
            <Col className="mb-5">
               <GreyCard>
                  <Row>
                     <Col className="d-flex justify-content-between align-items-center px-4 mt-3 mb-1">
                        <p
                           style={{
                              fontSize: "18px",
                              fontWeight: "bold",
                              color: "#454545",
                           }}
                        >
                           Procurement Info
                        </p>
                     </Col>
                  </Row>

                  <hr style={{ background: "#C4C4C4" }} />

                  {isLoading && (
                     <Row>
                        <Col className="px-4">
                           <Loader speed="fast" content="Getting procurement info..." />
                        </Col>
                     </Row>
                  )}

                  {!isLoading && (
                     <Row>
                        <Col className="px-4 mt-1">
                           <Form>
                              {formState?.procurementNumber && (
                                 <Form.Group
                                    as={Row}
                                    className="d-flex align-items-center mb-3"
                                    controlId="procurement_number"
                                 >
                                    <Form.Label column sm={3}>
                                       <p style={{ fontSize: "12px" }}>Procurement Number</p>
                                    </Form.Label>
                                    <Col className="d-flex align-items-center">
                                       <span>{formState.procurementNumber}</span>
                                    </Col>
                                 </Form.Group>
                              )}

                              <Form.Group as={Row} className="d-flex align-items-center mb-3" controlId="post_date">
                                 <Form.Label column sm={3}>
                                    <p style={{ fontSize: "12px" }}>Post Date</p>
                                 </Form.Label>
                                 <Col className="d-flex align-items-center">
                                    <Dateinfo style={{ all: "unset" }} date={formState.startDate} format="dd/mm/yyyy" />
                                 </Col>
                              </Form.Group>

                              <Form.Group
                                 as={Row}
                                 className="d-flex align-items-center mb-3"
                                 controlId="procurement_name"
                              >
                                 <Form.Label column sm={3}>
                                    <p style={{ fontSize: "12px" }}>Procurement Name</p>
                                 </Form.Label>
                                 <Col className="d-flex align-items-center">
                                    <span>{formState.procurementName}</span>
                                 </Col>
                              </Form.Group>

                              <Form.Group
                                 as={Row}
                                 className="d-flex align-items-center mb-3"
                                 controlId="negotiation_type"
                              >
                                 <Form.Label column sm={3}>
                                    <p style={{ fontSize: "12px" }}>Negotiation Type</p>
                                 </Form.Label>
                                 <Col className="d-flex align-items-center">
                                    <span>
                                       {
                                          dataMasters?.negotiationTypes.filter(
                                             (v) => v.value === formState.negotiationType,
                                          )[0]?.label
                                       }
                                    </span>
                                 </Col>
                              </Form.Group>

                              <Form.Group
                                 as={Row}
                                 className="d-flex align-items-center mb-3"
                                 controlId="evaluation_method"
                              >
                                 <Form.Label column sm={3}>
                                    <p style={{ fontSize: "12px" }}>Evaluation Method</p>
                                 </Form.Label>
                                 <Col className="d-flex flex-column align-items-start">
                                    <span>
                                       {
                                          dataMasters?.evaluationMethods.filter(
                                             (v) => v.value === formState.evaluationMethod,
                                          )[0]?.label
                                       }
                                    </span>
                                 </Col>
                              </Form.Group>

                              <Form.Group as={Row} className="d-flex align-items-center mb-3" controlId="winner_type">
                                 <Form.Label column sm={3}>
                                    <p style={{ fontSize: "12px" }}>Winner Type</p>
                                 </Form.Label>
                                 <Col className="d-flex flex-column align-items-start">
                                    <span>
                                       {
                                          dataMasters?.winnerTypes.filter((v) => v.value === formState.winnerType)[0]
                                             ?.label
                                       }
                                    </span>
                                 </Col>
                              </Form.Group>

                              <Form.Group as={Row} className="d-flex align-items-center mb-3" controlId="bidding_type">
                                 <Form.Label column sm={3}>
                                    <p style={{ fontSize: "12px" }}>Bidding Type</p>
                                 </Form.Label>
                                 <Col className="d-flex flex-column align-items-start">
                                    <span>
                                       {
                                          dataMasters?.biddingTypes.filter((v) => v.value === formState.biddingType)[0]
                                             ?.label
                                       }
                                    </span>
                                 </Col>
                              </Form.Group>

                              <Form.Group as={Row} className="d-flex align-items-center mb-3" controlId="currency_type">
                                 <Form.Label column sm={3}>
                                    <p style={{ fontSize: "12px" }}>Currency Type</p>
                                 </Form.Label>
                                 <Col className="d-flex align-items-center">
                                    <span>
                                       {
                                          dataMasters?.currencyTypes.filter(
                                             (v) => v._id === formState.currencyTypeId,
                                          )[0]?.label
                                       }
                                    </span>
                                 </Col>
                              </Form.Group>

                              {formState.currencyType === Constant.CURRENCY_TYPE.SINGLE_CURRENCY && (
                                 <Form.Group
                                    as={Row}
                                    className="d-flex align-items-center mb-3"
                                    controlId="currency_type"
                                 >
                                    <Form.Label column sm={3}>
                                       <p style={{ fontSize: "12px" }}>Currency</p>
                                    </Form.Label>
                                    <Col className="d-flex align-items-center">
                                       <span>
                                          {dataMasters?.currencies.find((v) => v._id == formState.currencyId).label}
                                       </span>
                                    </Col>
                                 </Form.Group>
                              )}

                              <Form.Group
                                 as={Row}
                                 className="d-flex align-items-center mb-3"
                                 controlId="price_include_tax"
                              >
                                 <Form.Label column sm={3}>
                                    <p style={{ fontSize: "12px" }}>Price Include TAX</p>
                                 </Form.Label>
                                 <Col className="d-flex align-items-center">
                                    <span>{formState.priceIncludeTax ? "Yes" : "No"}</span>
                                 </Col>
                              </Form.Group>
                           </Form>
                        </Col>
                     </Row>
                  )}
               </GreyCard>
            </Col>
         </Row>
      </div>
   )
}

const mapStateToProps = (state) => {
   return {
      isAppLoading: state.appReducer.isAppLoading,
      dataMasters: state.masterDataReducer.dataMasters,
      dataProcurementItems: state.procurementReducer.dataProcurementItems,
   }
}

export default connect(mapStateToProps)(InitiationInfoForm)
